import { Box, Card, CardContent, Divider, Stack, Typography } from "@mui/material"
import dayjs from "dayjs"

export default function VacationHolidaysCard({ holidays }) {
	if (!holidays?.length) {
		return null
	}

	return (
		<Stack spacing={2} sx={{ width: "100%" }}>
			<Divider />
			<Typography
				variant="h6"
				sx={{
					textAlign: "center",
				}}
			>
				Descanso
			</Typography>
			<Box
				display="flex"
				flexWrap="wrap"
				justifyContent="center"
				gap="30px"
				// height="25vh"
				maxHeight={"25vh"}
				p={2}
				sx={{
					scrollSnapAlign: "center",
					overflowY: "auto", // Habilita scroll vertical
				}}
			>
				{holidays.map((date, index) => {
					let fecha = dayjs(date?.date).format("DD/MM/YYYY")
					return (
						<div style={{ flex: "1 0 150px" }}>
							<Card
								sx={{
									minWidth: 100,
									height: "100%",
								}}
							>
								<CardContent
									sx={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										height: "100%",
									}}
								>
									<Typography
										sx={{
											// variant: "h7",
											whiteSpace: "pre-line",
											textAlign: "center",
										}}
									>{`${fecha} \n ${date.name}`}</Typography>
								</CardContent>
							</Card>
						</div>
					)
				})}
			</Box>
		</Stack>
	)
}
